import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';

export const mongooseSchemaValidation = () => {
    return yup.object().shape({
        name: yup.string().required(ERRORS.required),
        dataSchema: yup.mixed().test('', ERRORS.required, (val) => {
            if (Object.keys(val).length > 0) {
                return true;
            } else {
                return false;
            }
        }),
    });
};
